import { configureStore } from '@reduxjs/toolkit';
import tagsReducer from './slices/tagsSlice';
import donationFormReducer from './slices/donationFormSlice';
import transactionFormReducer from './slices/transactionFormSlice';
import contactDetailReducer from './slices/contactDetailSlice';
import donationReducer from './slices/donationSlice';
import reminderReducer from './slices/reminderSlice';
import transactionReducer from './slices/transactionSlice';
import donationSchemasReducer from './slices/donationSchemasSlice';

export const store = configureStore({
  reducer: {
    tags: tagsReducer,
    donationForm: donationFormReducer,
    transactionForm: transactionFormReducer,
    contactDetail: contactDetailReducer,
    donations: donationReducer,
    reminders: reminderReducer,
    transactions: transactionReducer,
    donationSchemas: donationSchemasReducer,
  },
});
